import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Institute Wise Training Statistics Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex pt-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
      ])
    ])
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Institute Wise Training Statistics Report ")
  ])
], -1)
const _hoisted_24 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = {
  class: "card-body border-top",
  style: {"overflow":"scroll"}
}
const _hoisted_27 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_36 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid black"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid black"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid black"} }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, "SL"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, "Course Name"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, "Tranche"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, "Batch Number"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2"
    }, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2"
    }, "Assessed"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2"
    }, "Certified"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2"
    }, "Job Placed"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2"
    }, " % of Job Placement "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Batch Start Date "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Batch End Date ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total% "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female% ")
  ])
], -1)
const _hoisted_38 = { style: {} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: this.trainingInstitute
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.entity_short_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.entity_name) + " [" + _toDisplayString(data.entity_short_name) + "] ", 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Institute",
                      modelValue: _ctx.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.institute_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.showBtnStatus
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: inst.id,
                            label: inst.institute_name,
                            value: inst.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(inst.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.showBtn)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.instituteTrainningStatisticReport())),
                          type: "button",
                          class: "btn btn-success mt-6 p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_17
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.instituteTrainningStatisticReport())),
                          type: "button",
                          disabled: "",
                          class: "btn btn-success mt-6 p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_18
                        ]))
                  ])
                ]),
                _hoisted_19,
                _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_29),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_31),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_33),
                              _hoisted_34,
                              _hoisted_35
                            ]),
                            _createElementVNode("table", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("tbody", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this
                                    .instituteTrainningStatistic, (data, inx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: inx,
                                    class: "border border-gray-400 text-center"
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.course_name), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.tranche), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.batch_number), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.enroll), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.enroll_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.assesment), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.assesment_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.certification), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.certification_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.job_placement), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.job_placement_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.percentage_of_job_placement.toFixed(
                                        2
                                      )), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.percentage_of_job_placement_female.toFixed(
                                          2
                                        )), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.moment(data?.batch_start_date).format(
                                        'DD-MM-YYYY'
                                      )), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.moment(data?.batch_end_date).format(
                                        'DD-MM-YYYY'
                                      )), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])), [
                        [_directive_loading, _ctx.load]
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}